// ======================================================================
// File Name       : SuperUserTopContainer.js
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { Component } from 'react';
import { Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
  exportSuperUserCSV,
  searchSuperUser
} from '../../actions/SuperUserAction';
import DialogConfirm from '../../components/DialogConfirm';
import Header from '../../components/Header';
import MessageSearch from '../../components/MessageSearch';
import CustomLink from '../../components/button/CustomLink';
import SuperUserList from '../../components/superUser/SuperUserList';
import SuperUserSearch from '../../components/superUser/SuperUserSearch';
import { SUPERUSER_REGISTER, SUPERUSER_SERVICE_ROLE_LIST } from '../../constants/FunctionConstants';
import * as Path from '../../constants/PathConstants';
import * as actionType from '../../constants/actionTypes/page';
import { RETURN_MAX_NUM, SELECT_TARGET_DATA } from '../../constants/index';
import { canAccessRoute } from '../../utils/AuthedUtils';

class SuperUserTopContainer extends Component {
  constructor() {
    super();
    this.state = {
      showBatchConfirm: false,
      searchInfo: {
        loginId: '',
        superuserName: '',
        enterpriseCd: '', //Step10.0.0
        enterpriseName: '',
        userSortType: null,
        ascendingDescendingSort: 0,
        startPosition: 0,
        returnMaxNum: RETURN_MAX_NUM,
      },
      recordNum: 0,
      superuserList: [],
      currentSearch: {
        userSortType: null,
        ascendingDescendingSort: 0,
        startPosition: 0,
      },
      isAllowShowSearchMessage: false,
      isInit: false,
    };

    this.handleSearchFormChange = this.handleSearchFormChange.bind(this);
    this.handleSearchBtn = this.handleSearchBtn.bind(this);
    this.onSearchBtn = this.onSearchBtn.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.openBatchDialog = this.openBatchDialog.bind(this);
    this.onOkBatch = this.onOkBatch.bind(this);
    this.onCancelBatch = this.onCancelBatch.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.onLoginExportBtnClick = this.onLoginExportBtnClick.bind(this);
  }

  componentWillMount() {
    if (this.props.parentPath === Path.SUPERUSER_LIST) {
      this.setState({
        ...this.state,
        currentSearch: this.props.searchCondition,
        searchInfo: this.props.searchCondition,
        isInit: true,
      });
    }
  }

  componentDidMount() {
    this.getSuperUserList(SELECT_TARGET_DATA.DATA);
  }

  componentWillUnmount() {
    const searchCondition = this.state.currentSearch;
    searchCondition.startPosition = this.state.searchInfo.startPosition;
    searchCondition.userSortType = this.state.searchInfo.userSortType;
    searchCondition.ascendingDescendingSort = this.state.searchInfo.ascendingDescendingSort;
    this.props.dispatch({
      type: actionType.SAVE_SEARCH_CONDITION,
      parentPath: Path.SUPERUSER_LIST,
      searchCondition,
    });
  }

  /**
   * Get user list
   *
   * @param {Interger} selectTargetData
   */
  getSuperUserList(selectTargetData) {
    const { dispatch } = this.props;
    const { searchInfo } = this.state;
    const { currentSearch } = this.state;
    currentSearch.startPosition = this.state.searchInfo.startPosition;
    currentSearch.userSortType = this.state.searchInfo.userSortType;
    currentSearch.returnMaxNum = this.state.searchInfo.returnMaxNum;
    currentSearch.ascendingDescendingSort = this.state.searchInfo.ascendingDescendingSort;
    currentSearch.returnMaxNum = RETURN_MAX_NUM;
    if (selectTargetData === SELECT_TARGET_DATA.DATA) {
      dispatch(searchSuperUser(currentSearch)).then(() => {
        if (!this.state.isInit) {
          this.setState({ isAllowShowSearchMessage: true });
        }
      });
    } else {
      dispatch(exportSuperUserCSV(searchInfo));
    }
  }

  componentWillReceiveProps(nextProps) {
    const { superUser } = nextProps;
    const { superuserList, recordNum } = superUser;
    this.setState({
      superuserList,
      recordNum,
    });
  }

  handleSearchFormChange(event) {
    const { name, value } = event.target;
    const searchInfo = { ...this.state.searchInfo, ...{ [name]: value } };
    this.setState({
      searchInfo,
    });
  }

  /**
 * Handle search when click on search button
 *
 */
  onSearchBtn() {
    const searchInfo = {
      ...this.state.searchInfo,
      userSortType: null,
      ascendingDescendingSort: 0,
      startPosition: 0,
    };
    const currentSearch = {
      ...this.state.searchInfo,
      ...(this.state.currentSearch = this.state.searchInfo),
    };
    this.setState(
      {
        searchInfo,
        currentSearch,
        isAllowShowSearchMessage: false,
        isInit: false,
      }, () => {
      this.getSuperUserList(SELECT_TARGET_DATA.DATA);
    });
  }

  handleSearchBtn() {
    this.getSuperUserList(SELECT_TARGET_DATA.DATA);
  }

  /**
   * Handle export cvs when click on export button
   */
  handleExportBtn() {
    this.getSuperUserList(SELECT_TARGET_DATA.CSV);
  }

  /**
 * Handle event when click on header of table, call API to sort data
 *
 * @param row
 */
  handleSortState(row) {
    const { searchInfo } = this.state;
    searchInfo.ascendingDescendingSort = row.sortState;
    searchInfo.userSortType = row.sortBy;
    this.setState(
      {
        searchInfo,
      },
      () => {
        this.getSuperUserList(SELECT_TARGET_DATA.DATA);
      },
    );
  }

  /**
 * Handle event when user change page on paging
 * @param page
 */
  getStartEndData(startPosition) {
    const searchInfo = {
      ...this.state.searchInfo,
      ...{ startPosition },
    };
    this.setState(
      {
        searchInfo,
      }, () => { this.getSuperUserList(SELECT_TARGET_DATA.DATA); },
    );
  }

  /**
     * Handle event on 一括出力
     * @param mdContent
     * @param mdSize
     */
  openBatchDialog(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showBatchConfirm: true });
  }

  /**
     * Handle event when click on キャンセル of 一括出力 dialog
     */
  onCancelBatch() {
    this.setState({ showBatchConfirm: false });
  }

  /**
     * Handle event when click on OK of 一括出力 dialog
     */
  onOkBatch() {
    this.setState({ showBatchConfirm: false });
    this.getSuperUserList(SELECT_TARGET_DATA.CSV);
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }

  // Step 10.0.0 START
  onLoginExportBtnClick() {
    const { history } = this.props;
    history.push(Path.LOGIN_HISTORY_ENTERPRISE_CSV_DOWNLOAD);
  }
  // Step 10.0.0 END

  render() {
    const { recordNum, superuserList, hoverIndex } = this.state;
    const { readOnlyFlag, isBelongServiceGroup } = this.props;
    const canEditSuperuser = canAccessRoute(SUPERUSER_REGISTER);
    const canAccessSuperuserRole = canAccessRoute(SUPERUSER_SERVICE_ROLE_LIST)
    return (
      <Col className="padding-left-clear">
        <MessageSearch
          recordNum={recordNum}
          resultList={superuserList}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <Col sm={12} className="padding-left-right-clear">
          <Col sm={3} className="padding-left-right-clear">
            <Header name="SuperUser管理" />
          </Col>
          {canAccessSuperuserRole && (
          <Col sm={9} className="margin-top-20 float-end padding-left-right-clear align-right align-self-center">
            <Col sm={12} className="padding-left-right-clear">
              <CustomLink
                className="margin-right-7 link-authority bold inline-flex line-height-20"
                to={Path.SUPERUSER_ENTERPRISE_ROLE_LIST}
                text="SuperUser企業ロール設定"
              />
            </Col>
            <Col sm={12} className="margin-top-10 padding-left-right-clear">
              <CustomLink
                className="margin-right-7 link-authority bold inline-flex line-height-20"
                to={Path.SUPERUSER_SERVICE_ROLE_LIST}
                text="SuperUserサービスロール設定"
              />
            </Col>
          </Col>
          )}
        </Col>
        <SuperUserSearch
          {...this.state.searchInfo}
          handleChange={this.handleSearchFormChange}
          onSearchBtnClick={this.onSearchBtn}
          openBatchDialog={this.openBatchDialog}
          readOnlyFlag={readOnlyFlag}
          canEditSuperuser={canEditSuperuser}
          onLoginExportBtnClick={this.onLoginExportBtnClick}
          isBelongServiceGroup={isBelongServiceGroup}
        />
        <SuperUserList
          superuserList={superuserList}
          handleSortState={this.handleSortState}
          searchInfo={this.state.searchInfo}
          getStartEndData={this.getStartEndData}
          recordNum={recordNum}
          startPosition={this.state.searchInfo.startPosition}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
          hoverIndex={hoverIndex}
        />
        <DialogConfirm
          showModal={this.state.showBatchConfirm}
          content={this.content}
          onCancel={this.onCancelBatch}
          onOK={this.onOkBatch}
        />
      </Col>
    );
  }
}


const mapStateToProps = (state, ownProps) => {
  const { parentPath, searchCondition } = state.page;
  const { readOnlyFlag, isBelongServiceGroup } = state.authed.authedUser;
  return ({
    ...{ superUser: state.superUser },
    parentPath,
    searchCondition,
    readOnlyFlag,
    isBelongServiceGroup,
  });
};

export default connect(mapStateToProps)(SuperUserTopContainer);
